function camelToSnake(str: string) {
    return str
        .replace(/([A-Z])/g, '_$1')
        .toLowerCase();
}


/**
 * Recursively converts the keys of a camelCase object to snake_case.
 * - Handles nested objects
 * - Handles arrays
 * - Does not modify values (only keys)
 * - Ignores non-simple objects (Date, Map, etc.)
 * @param obj (any) - Object or array to transform
 * @returns (any) New object with snake_case keys
 */
export function keysToSnake(obj: any): any {
    if (Array.isArray(obj)) {
        return obj.map(keysToSnake);
    }

    if (obj !== null && typeof obj === 'object' && obj.constructor === Object) {
        return Object.keys(obj).reduce((acc: any, key) => {
            const newKey = camelToSnake(key);
            acc[newKey] = keysToSnake(obj[key]);
            return acc;
        }, {});
    }

    return obj;
}
